// extracted by mini-css-extract-plugin
export default {"wrapper":"SideBySide_wrapper__mmG7j","img":"SideBySide_img__qiQbL"};